import Cookies from "js-cookie"
import { API_KEY } from "../constants/auth"

export const signOut = () => {
    Cookies.remove(API_KEY)
}